<template>
  <div id="app">

     <Header></Header>
    <router-view/>


  </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import {mapActions, mapMutations, mapState} from 'vuex'

    export default {
        name: "App",
        created: function() {
          const template = localStorage.getItem("template");
          if (template) {
              this.SET_TEMPLATE(template);
          } else {
              this.SET_TEMPLATE('black');
          }
        },
        updated: function() {

            if (this.template === 'white'){
                window.document.body.style.background = 'var(--white)'
                window.document.children[0].style.background = 'var(--white)'
            } else {
                window.document.body.style.background = 'var(--color)'
                window.document.children[0].style.background = 'var(--color)'
            }

        },
        components: {
            Header
        },
        computed: mapState([
            'template'
        ]),
        methods: {
            ...mapMutations([
                'SET_TEMPLATE',
            ]),
        }
    }
</script>

<style lang="scss">
  @import "style/base";

  :root {
    --size: 100%;
    --color: #111111;
    --white: #FFFFFF;
  }


  html, body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    height: 100%;
    width: 100%;
    font-family: Roboto;
    font-size: 14px;
    color: #888888;
    min-width: 400px;
    background: var(--white);
      transition: .5s background ease-in-out;
  }

  .black {
      transition: .5s all ease-in-out
  }
  .white {
      transition: .5s all ease-in-out
  }

  body {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  #app {
    position: relative;
  }

  .title {
    font-family: Montserrat;
    color: #000000;
  }

  a {
    text-decoration: none !important;
  }

  .dvBoton {
    @include botonDefault;
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes outFade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .toggleWrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      overflow: hidden;
      padding: 0 200px;
      transform: translate3d(-50%, -50%, 0);

      input {
          position: absolute;
          left: -99em;
      }
  }

  .toggle {
      cursor: pointer;
      display: inline-block;
      position: relative;
      width: 70px;
      height: 30px;
      background-color: #83D8FF;
      border-radius: 90px - 6;
      transition: background-color 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);

  }

  .toggle__handler {
      display: inline-block;
      position: relative;
      z-index: 1;
      top: 3px;
      left: 3px;
      width: 30px - 6;
      height: 30px - 6;
      background-color: #FFCF96;
      border-radius: 50px;
      box-shadow: 0 2px 6px rgba(0,0,0,.3);
      transition: all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
      transform:  rotate(-45deg);

      .crater {
          position: absolute;
          background-color: #E8CDA5;
          opacity: 0;
          transition: opacity 200ms ease-in-out;
          border-radius: 100%;
      }

      .crater--1 {
          top: 10px;
          left: 3px;
          width: 3px;
          height: 3px;
      }

      .crater--2 {
          top: 16px;
          left: 12px;
          width: 4px;
          height: 4px;
      }

      .crater--3 {
          top: 4px;
          left: 10px;
          width: 8px;
          height: 8px;
      }
  }

  .star {
      position: absolute;
      background-color: #ffffff;
      transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
      border-radius: 50%;
  }

  .star--1 {
      top: 5px;
      left: 18px;
      z-index: 0;
      width: 20px;
      height: 3px;
  }

  .star--2 {
      top: 12px;
      left: 18px;
      z-index: 1;
      width: 25px;
      height: 3px;
  }

  .star--3 {
      top: 20px;
      left: 18px;
      z-index: 0;
      width: 20px;
      height: 3px;
  }

  .star--4,
  .star--5,
  .star--6 {
      opacity: 0;
      transition: all 300ms 0 cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }

  .star--4 {
      top: 8px;
      left: 31px;
      z-index: 0;
      width: 2px;
      height: 2px;
      transform: translate3d(3px,0,0);
  }

  .star--5 {
      top: 22px;
      left: 27px;
      z-index: 0;
      width: 3px;
      height: 3px;
      transform: translate3d(3px,0,0);
  }

  .star--6 {
      top: 14px;
      left: 26px;
      z-index: 0;
      width: 2px;
      height: 2px;
      transform: translate3d(3px,0,0);
  }

  input:checked {
      + .toggle {
          background-color: #749DD6;

          &:before {
              color: #749ED7;
          }

          &:after {
              color: #ffffff;
          }

          .toggle__handler {
              background-color: #FFE5B5;
              transform: translate3d(40px, 0, 0) rotate(0);

              .crater { opacity: 1; }
          }

          .star--1 {
              width: 2px;
              height: 2px;
          }

          .star--2 {
              width: 4px;
              height: 4px;
              transform: translate3d(-5px, 0, 0);
          }

          .star--3 {
              width: 2px;
              height: 2px;
              transform: translate3d(-7px, 0, 0);
          }

          .star--4,
          .star--5,
          .star--6 {
              opacity: 1;
              transform: translate3d(0,0,0);
          }
          .star--4 {
              transition: all 300ms 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
          }
          .star--5 {
              transition: all 300ms 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
          }
          .star--6 {
              transition: all 300ms 400ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
          }
      }
  }

</style>
